module.exports = __webpack_public_path__ + "static/media/body_system_dropdown.01532ce3.svg";